<template>
    <v-dialog
        v-if="$rc.inIndustry('wine')"
        v-model="show_modal"
        max-width="800"
        persistent
        scrollable
    >
        <v-card>
            <v-card-title class="error white--text">
                <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
                Emerging Carrier Issue
            </v-card-title>

            <v-card-text class="pt-4">
                <strong>Emerging Carrier Issue</strong>
                        
                <p
                    style="margin-top: 5px"
                >
                    About two weeks ago, we were notified of unusual carrier blocks affecting three wineries in rapid succession. 
                    All originated from a single aggregator in the messaging ecosystem. 
                    When a winery is blocked, all of that winery's messaging through that aggregator is suspended until resolved — 
                    not just promotional messages — which can interrupt other important communications.
                </p>

                <p>
                    <b>Current status:</b> Messaging has been restored for the affected wineries, and we have not seen additional blocks.
                </p>

                <p>
                    <b>What to do now:</b>
                    <ul>
                        <li>If your next promotional message can wait, consider delaying briefly while we gather more clarity.</li>
                        <li>If it can’t wait, consider using indirect promotional language.</li>
                        <li>Watch for an upcoming RedChirp prompt to begin toll-free number registration, which can provide an alternative messaging path.</li>
                    </ul>
                </p>

                <a href="https://redchirp.com/emerging-carrier-issue-updates-week-of-jan-5th/" target="_blank">Read the full update for details, examples, and next steps.</a>

            </v-card-text>

            <v-card-actions class="shaded-light">
                <v-spacer />
                <v-btn
                    color="primary"
                    @click="onDismiss"
                >
                    I Understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';

const STORAGE_KEY = 'winery_carrier_alert_dismissed';

export default {
    name: 'TempDisableWineriesFromSchedulingModal',

    /*components: {
        WineryCarrierAlertContent,
    },*/

    data() {
        return {
            show_details: false,
            show_modal: false,
        };
    },

    mounted() {
        this.checkShouldShow();
    },

    methods: {
        checkShouldShow() {
            const dismissed_date = localStorage.getItem(STORAGE_KEY);
            const today = new Date().toISOString().split('T')[0];

            if (dismissed_date !== today) {
                this.show_modal = true;
            }
        },

        onDismiss() {
            const today = new Date().toISOString().split('T')[0];
            localStorage.setItem(STORAGE_KEY, today);
            this.show_modal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>
